 
import { useState, useEffect } from 'react';
 
 
export default function BlockText({ block, setEditingBlock, updateBlock }) {
 
  
 
    function handleContentChange(e)
    {
       
        block.content = e.target.value;
        updateBlock(block.id, 'content', String(e.target.value));
    }
 
    return (
        <div>
            <label className="block font-semibold mb-2">Script:</label>
            <div className="p-2 bg-gray-100 rounded">
                <textarea
                    value={block.content}
                    onChange={handleContentChange}
                   
                    style={{height: '200px', width: '100%', border: '1px solid #ccc', borderRadius: '5px', padding: '10px'}}
                />
            </div>
        </div>
    );
}
